module.exports = __webpack_public_path__ + "banquet/components/AccountSettings/images/push_toggle_highlight.224447e91097650694364f0fce21f9e7.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AccountSettings/images/push_toggle_highlight.svg
// module id = 1646
// module chunks = 1